import React, { createContext, useContext, useState, useEffect } from "react";
import { useCustomCampaignShowContext } from "../CustomCampaignShowContainer";

export const BeefreeComposerTemplatableContext = createContext();

export function useBeefreeComposerTemplatableContext() {
  return useContext(BeefreeComposerTemplatableContext);
}

export const BeefreeComposerTemplatableProvider = (props) => {
  const {
    csrfToken,
    team,
    beefreeToken,
    selectedNode,
    venueOwnership,
  } = useCustomCampaignShowContext();

  const [beefreeTemplateId, setBeefreeTemplateId] = useState(0);

  useEffect(() => {
    setBeefreeTemplateId(selectedNode.beefree_template?.id);
  }, [selectedNode]);

  const value = {
    ...props,
    csrfToken,
    team,
    beefreeToken,
    beefreeTemplateId,
    venueOwnership,
  };

  return (
    <BeefreeComposerTemplatableContext.Provider value={value}>
      {props.children}
    </BeefreeComposerTemplatableContext.Provider>
  );
};
